import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import SweetAlert from "react-bootstrap-sweetalert";

import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import cellEditFactory from "react-bootstrap-table2-editor";
import "../../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import Select from "react-select";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import {  convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered,  } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import UpdateQuantityModal from "../../../../components/UpdateQuantityModal";

const FinishedProductUrgentOrders = (props) => {

  const urlParams = new URLSearchParams(window.location.search);
  const { SearchBar } = Search;
  const selectRef = useRef()
  const [confirmApprove, setConfirmApprove] = useState(false);
  const [confirmReject, setConfirmReject] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [selectedSection, setSelectedSection] = useState(
    urlParams.get("section") ? urlParams.get("section") : "All"
  );
  const [selectedStatus, setSelectedStatus] = useState(
    urlParams.get("status") ? urlParams.get("status") : "All"
  );
  useEffect(() => {
    if (urlParams.get("section")) {
      setSelectedSection(urlParams.get("section"));
    }
    if (urlParams.get("status")) {
      setSelectedStatus(urlParams.get("status"));
    }
    loadAllBranches();
    loadAllSections();
  }, []);
  const [confirmClose, setConfirmClose] = useState(false);


  useEffect(() => {
    loadAllOrders();
  }, [selectedSection, selectedBranch]);

  const [allOrders, setAllOrders] = useState([]);
  const [availableStatuses, setAvailableStatuses] = useState([]);
  const loadAllOrders = async () => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "productorders/getall_urgent_orders";
    const response = await postSubmitForm(url, {
      branch: selectedBranch,
      section: selectedSection,
      status: "All",
    });
    if (response && response.status === 1) {
      preloader(false);
      const orders = response.data || [];
      const statuses = [...new Set(orders.map((order) => order.status).filter(Boolean))];
      setAllOrders(orders);
      setAvailableStatuses(statuses);
      setSelectedStatus((current) =>
        current !== "All" && !statuses.includes(current) ? "All" : current
      );
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const [allMappedProducts, setAllMappedProducts] = useState([]);
  const [isMappedLoading, setIsMappedLoading] = useState(false);
  const mappedStoreIdRef = useRef(null);
  const [enterQuantityModal, setEnterQuantityModal] = useState(false)
  const [confirmRemove, setConfirmRemove] = useState(false)
  const loadMappedItems = async (store) => {
    if (!store || !store._id) return;
    if (mappedStoreIdRef.current === store._id && allMappedProducts.length > 0) {
      return;
    }
    try {
      setIsMappedLoading(true);
      let url = process.env.REACT_APP_BASEURL + "products/get_mapped_products";
      const response = await postSubmitForm(url, { store_id: store._id });
      if (response && response.status === 1) {
        const selectOptions = response.data.map((prod) => ({
          // ...item,
            product_id: prod.product_id,
            value: prod.product_id,
            label: prod.name,
            name: prod.name,
            brand: prod.brand,
            section: prod.section,
            category: prod.category,
            quantity: [],
            delivered_quantity: [],
            available: prod.store_available,
            branch_available: prod.available,
            unit_for_max_order: prod.unit_for_max_order,
            unit_levels:prod.unit_levels
        }));
        mappedStoreIdRef.current = store._id;
        setAllMappedProducts(selectOptions);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error, "Error")
    } finally {
      setIsMappedLoading(false);
    }
  };

  const [allSections, setAllSections] = useState([]);
  const loadAllSections = async () => {
    let url = process.env.REACT_APP_BASEURL + "productsections/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllSections(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [allBranches, setAllBranches] = useState([]);
  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter((store)=>store.type==="Branch")
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleApproveOrder = async () => {
    let url = process.env.REACT_APP_BASEURL + "productorders/set_approved";

    const response = await postSubmitForm(url, {
      productorder_id: selectedOrder._id,
    });
    //console.log(data_to_send);
    if (response && response.status === 1) {
      loadAllOrders();
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [rejectRemarks, setRejectRemarks] = useState();
  const [rejectModal, setRejectModal] = useState();
  const handleRejectOrder = async (e, v) => {
    let url = process.env.REACT_APP_BASEURL + "productorders/set_rejected";

    const response = await postSubmitForm(url, {
      productorder_id: selectedOrder._id,
      admin_remarks: rejectRemarks,
    });
    //console.log(data_to_send);
    if (response && response.status === 1) {
      loadAllOrders();
      setRejectRemarks('')
      setRejectModal(!rejectModal);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
    },
    {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity)
       },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Branch Avl. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available,row.unit_levels)
       },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "central_available",
      text: props.t("Central Avl. Qty."),
      formatter: (cell, row) => {
        return  formatUnitsForReport(row.central_available,row.unit_levels)
       },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];
  const [selectedOrder, setSelectedOrder] = useState();
  const handleCloseOrder = async () => {
    let url = process.env.REACT_APP_BASEURL + "productorders/set_closed";
    const response = await postSubmitForm(url, {
      productorder_id: selectedOrder._id,
      admin_remarks: adminRemarks,
    });
    //console.log(data_to_send);
    if (response && response.status === 1) {
      loadAllOrders();
      setRemarksModal(!remarksModal);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [remarksModal, setRemarksModal] = useState();
  const [adminRemarks, setAdminRemarks] = useState();
  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "branch_details.name",
      text: props.t("Branch Name"),

      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      text: props.t("Order Date"),
      dataField: "date_to_process",
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      // formatter: (cell, row) => {
      //   return moment(row.date_to_process).format("DD-MM-YYYY HH:mm");
      // },
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Is Urgent?"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      formatter: (cell, row) => {
        if (row.is_urgent) {
          return props.t("Yes");
        } else {
          return props.t("No");
        }
      },
      style: { cursor: "pointer" },
    },

    {
      dataField: "status",
      text: props.t("Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      text: props.t("Action"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
          {row.status==="Placed" ? (
              <>
              <button
                class="btn btn-info btn-sm mr-2"
                onClick={() => {
                  setConfirmApprove(true);
                  setSelectedOrder(row);
                }}
              >
                {props.t("Accept")}
              </button>
              <button
                class="btn btn-danger btn-sm mr-2"
                onClick={() => {
                  setRejectModal(true);
                  setSelectedOrder(row);
                }}
              >
                {props.t("Reject")}
              </button>
            </>
          ) : row.status === "Rejected" ? (
            <button
              class="btn btn-danger btn-sm mr-2"
              onClick={() => {
                setRemarksModal(!remarksModal);
                setSelectedOrder(row);
              }}
            >
              {props.t("Close")}
            </button>
          ) : (
<>
{row.status !== "Dispatched" && (
<button
              class="btn btn-secondary btn-sm mr-2"
              onClick={() => {
                setSelectedOrder(row);
                setProductsForDelivery([]);
                setAllMappedProducts([]);
                mappedStoreIdRef.current = null;
                setOrderDispatchModal(true);
                loadProductsForDelivery(row._id);
              }}
            >
              {props.t("Dispatch")}
            </button>
)}
            <button
              class="btn btn-danger btn-sm mr-2"
              onClick={() => {
                setRemarksModal(!remarksModal);
                setSelectedOrder(row);
              }}
            >
              {props.t("Close")}
            </button>
</>
          )}
           
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
  ];
 
  const handleOnExpand = (row, isExpand, rowIndex, e) => {
    if (isExpand) {
      setExpanded([...expanded, row._id]);
    } else {
      setExpanded(expanded.filter((x) => x !== row._id));
    }
  };
  const [expanded, setExpanded] = useState([]);
  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="_id"
          data={row.product_details}
          columns={columns}
          noDataIndication="No data to display."
          striped
          hover
          condensed
        />
      </div>
    ),
    expanded: expanded,
    onExpand: handleOnExpand,
  };
  const rowStyle = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8", fontWeight: "500" };
    return style;
  };

  //#region Dispatch order related code
  const validateProductDispatch = (prod) => {
    
    const availableQty = convertToLowestUnit(prod.unit_levels, prod.available ||[]);
    const dispatchQty = convertToLowestUnit(prod.unit_levels, prod.delivered_quantity || []);
    if (dispatchQty > availableQty) {
      return {
        isValid: false,
        message: `Dispatch quantity for <strong>${ prod.name }</strong > exceeds store available quantity.`
      };
  }

  return { isValid: true };
};
  const [productsForDelivery, setProductsForDelivery] = useState([]);
  const [isShowDispatch, setIsShowDispatch] = useState();
  const [isDispatchLoading, setIsDispatchLoading] = useState(false);
  const loadProductsForDelivery = async (productorder_id) => {
    setIsDispatchLoading(true);
    let url =
      process.env.REACT_APP_BASEURL + "productorders/get_products_to_dispatch";

    try {
      const response = await postSubmitForm(url, { productorder_id });

      if (response && response.status === 1) {
        // setIsShowDispatch(response.data.show_dispatch);
        handleSetProductsForFullDelivery(response.data.to_dispatch || [])
        // setProductsForDelivery(response.data.to_dispatch);
      } else {
        showNotification(response.message, "Error");
      }
    } finally {
      setIsDispatchLoading(false);
    }
  };
  const handleSetProductsForFullDelivery = async (products) => {    
    
    if (products.length > 0) {
      let new_arr = products.map((prod) => {
        let obj = {
          is_new_product_added: prod.is_new_product_added,
          product_id: prod.product_id,
          name: prod.name,
          brand: prod.brand,
          section: prod.section,
          category: prod.category,
          initial_order_quantity: prod.initial_order_quantity,
          quantity: prod.quantity.map(({unit,value})=>({unit,value})),
          delivered_quantity: prod.quantity.map(({unit,value})=>({unit,value})),
          available: prod.available,
          unit_levels:prod.unit_levels
        };
        return obj;
      });
      setProductsForDelivery(new_arr);
    } else {
      setProductsForDelivery([]);
    }
};
  const [selectedProduct, setSelectedProduct] = useState()
  const [editQuantityModal, setEditQuantityModal] = useState(false);
  const columns_products_to_dispatch = [
    {
      dataField: "product_id",
      hidden: true,
    },
    {
      text: props.t("Product"),
      dataField: "name",
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Section"),
      dataField: "section",
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Qty."),
      formatter: (cell, row) => {
       return  formatUnitsForReport(row.quantity,row.unit_levels)
      },
      sort: false,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "delivered_quantity",
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <span className="me-2">
               {formatUnitsForReport(row.delivered_quantity)}
              </span>

                <Button
                  className="btn btn-success btn-sm"
                  onClick={() => {
                    const updatedItem = {
                      ...row,
                      quantity: row.delivered_quantity.map((item, idx) => ({
                        ...item,
                        index: idx,
                        isChecked: true,
                      })),
                    };
                    setSelectedProduct(updatedItem)
                    setEditQuantityModal(true);
                  }}
                >
                  {props.t("Edit")}
                </Button>
            </div>
          </>
        )
      },
      text: props.t("Deliver Quantity"),
      sort: false,
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Central Avl. Qty."),
      editable: false,
      formatter: (cell, row) => {
       return  formatUnitsForReport(row.available,row.unit_levels)
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "",
      text: props.t("Remove"),
      sort: false,
      hidden:false,
      editable: false,
      formatExtraData: productsForDelivery,
      formatter: deleteFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
  const [orderDispatchModal, setOrderDispatchModal] = useState();

  const columns_delivered_products = [
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Del. Qty."),
      dataField: "delivered_quantity",
      formatter:(cell,row)=>{
        return formatUnitsForReport(row.delivered_quantity,row.unit_levels)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Rec. Qty."),
      dataField: "received_quantity",
      formatter:(cell,row)=>{
        return formatUnitsForReport(row.received_quantity,row.unit_levels)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Received?"),
      dataField: "is_received",
      formatter: (cell, row) => {
        return row.is_received ? "Yes" : "No";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];

  const handleRemoveProduct = async () => {
    let url = process.env.REACT_APP_BASEURL + "productorders/delete_product";
    const response = await postSubmitForm(url, {
      order_id: selectedOrder.order_id,
      product_id : selectedProduct.product_id
      // admin_remarks: adminRemarks,
    });

    if (response && response.status === 1) {
      showNotification(response.message, "Success");
      setProductsForDelivery((prev) => {
        const updatedCartProducts = prev.filter((item) => item.product_id !== selectedProduct?.product_id);
        return updatedCartProducts;
      });
      setSelectedOrder((prev) => ({
        ...prev,
        product_details: prev.product_details.filter(
          (item) => item.product_id !== selectedProduct?.product_id
        )
      }));
      setConfirmRemove(false)
      setSelectedProduct()
    } else {
      setSelectedProduct()
      showNotification(response.message, "Error");
    }
  };

const [isDisabled, setIsDisabled] = useState(false)
const handleDispatchOrder = async () => {
  let isValid = true
  if (productsForDelivery.length > 0) {
    for (const product of productsForDelivery) {
      const validationResult = validateProductDispatch(product);
      if (!validationResult.isValid) {
        isValid = false;
        showNotification(validationResult.message, "Warning");
        return
      }
    }
    setIsDisabled(true)
    // setProductsForDelivery(new_arr);
    let data_to_send = {};
    data_to_send.productorder_id = selectedOrder._id;
    data_to_send.branch_id = selectedOrder.branch_details._id;
    data_to_send.delivery_details = productsForDelivery;
    data_to_send.isPartialDelivery = false;
    let url = process.env.REACT_APP_BASEURL + "productorders/dispatch";
    // console.log(data_to_send,"ds"); return
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      loadAllOrders();
      setIsDisabled(false)
      showNotification(response.message, "Success");
      setOrderDispatchModal(!orderDispatchModal);
    } else {
      setIsDisabled(false)
      showNotification(response.message, "Error");
    }
  } else {
    setIsDisabled(false)
    showNotification("Add at least one product.", "Error");
  }
};

const [confirmRemoveProduct, setConfirmRemoveProduct] = useState(false)
  function deleteFormatter(cell, row, rowIndex, extraData) {
    return (
      <>
        <span className="text-danger">
          <i
              className="bx bxs-trash font-size-20 mt-1 text-danger"
              title="Click to Remove"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setConfirmRemoveProduct(true)
              setSelectedProduct(row)
            }}
          ></i>
        </span>
      </>
    );
  }
  //#endregion
  const handleUpdateQuantity = (quantity) => {    
    setEditQuantityModal(!editQuantityModal)
    const updatedProducts = productsForDelivery.map(prod => {
      let convertedQuantity = GetUpdatedDelivered(quantity,selectedProduct.unit_levels)
      if (prod.product_id === selectedProduct.product_id) {
        return {...prod,delivered_quantity:convertedQuantity.map(({unit,value})=>({unit,value}))};
      }
      return prod;
    });    
    setSelectedProduct()
    setProductsForDelivery(updatedProducts)
  };
  function handleCloseModal() {
    selectRef.current.select.clearValue()
    setEnterQuantityModal(false);
    setSelectedProduct()
  }

  const refForForm = useRef(null);
  const [isAdding, setIsAdding] = useState(false)
  const handleAddProductInDispatch = async (e,v) => {
    try {
      e.preventDefault()
      let arrangement_quantity = [{unit:selectedProduct.unit_for_max_order, value:Number(v.arrangement_quantity)}]
      setIsAdding(true)
    let convertedQuantity = GetUpdatedDelivered(arrangement_quantity, selectedProduct.unit_levels);
    let totalEntered =   convertToLowestUnit(selectedProduct.unit_levels,convertedQuantity)
    let totalCentralAvailable = convertToLowestUnit(selectedProduct.unit_levels,selectedProduct?.available);
    if(totalEntered>totalCentralAvailable){
      showNotification(`can not add more than available`,"Warning")
      return
    }    
    let productToBeAdded = {
      ...selectedProduct,
      quantity: convertedQuantity,
      initial_order_quantity: convertedQuantity,
      is_new_product_added:true,
      arrangement_quantity,
      delivered_quantity: convertedQuantity
    }
    let updatedProducts = [...productsForDelivery, productToBeAdded]
    let payload = {
      order_id :selectedOrder.order_id,
      product_details :productToBeAdded
    };
    let url = process.env.REACT_APP_BASEURL + "productorders/add_product";
    const response = await postSubmitForm(url, payload);
    if(response.status===1){
      showNotification(response.message, "Success")
      setProductsForDelivery(updatedProducts)
      selectRef.current.select.clearValue()
      setEnterQuantityModal(false);
      setSelectedProduct()
      return true
    }else{
      showNotification(response.message,"Error")
      return false
    }
    } catch (error) {
      console.log(error,"erro");
      return false
    } finally {
      setIsAdding(false)
    }
  };

  const displayedOrders =
    selectedStatus && selectedStatus !== "All"
      ? allOrders.filter((order) => order.status === selectedStatus)
      : allOrders;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Finished Products")}
            title={props.t("Central Kitchen")}
            breadcrumbItem1={props.t("FP Order")}
            breadcrumbItem2={props.t("Urgent Orders")}
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Urgent Orders")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all urgent orders here")}
                  </CardSubtitle>
                  
                  <ToolkitProvider
                    keyField="_id"
                    data={displayedOrders}
                    columns={columns_external}
                    noDataIndication={props.t("No data to display.")}
                    bootstrap4
                    search
                  >
                    {(props_table) => (
                      <div>
                        <AvForm>
                          <Row>
                            <Col lg={3}>
                              <Label>{props.t("Search")}</Label>
                              <SearchBar
                                {...props_table.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={3}>
                              <AvField
                                name="order_status"
                                label={props.t("Status")}
                                type="select"
                                value={selectedStatus}
                                onChange={(e) => {
                                  setSelectedStatus(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {availableStatuses.map((status) => (
                                  <option key={status} value={status}>
                                    {props.t(status)}
                                  </option>
                                ))}
                              </AvField>
                            </Col>
                            <Col lg={3}>
                              <AvField
                                name="branch"
                                label={props.t("Branch")}
                                type="select"
                                value={selectedBranch}
                                onChange={(e) => {
                                  setSelectedBranch(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allBranches &&
                                  allBranches.map((branch) => {
                                    return (
                                      <option value={branch._id}>
                                        {branch.name}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                            <Col lg={3}>
                              <AvField
                                name="section"
                                label={props.t("Section")}
                                type="select"
                                value={selectedSection}
                                onChange={(e) => {
                                  setSelectedSection(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allSections &&
                                  allSections.map((section) => {
                                    return (
                                      <option value={section.section}>
                                        {section.section}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                          </Row>
                        </AvForm>
                        <BootstrapTable
                          striped
                          hover
                          condensed
                          expandRow={expandRow}
                          rowStyle={rowStyle}
                          {...props_table.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                  <Modal
                    size="lg"
                    isOpen={orderDispatchModal}
                    toggle={() => setOrderDispatchModal(!orderDispatchModal)}
                  >
                    <ModalHeader
                      toggle={() => setOrderDispatchModal(!orderDispatchModal)}
                    >
                      {props.t("Dispatch Order")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col md={12}>
                                    <Link
                                      to="#"
                                      onClick={() => {
                                        printDiv("printOrdered");
                                      }}
                                      className="btn btn-sm btn-success mr-2"
                                    >
                                      <i className="fa fa-print"></i> Print
                                    </Link>

                                    <div id="printOrdered">
                                      <Col lg={12} md={12}>
                                        <Label>Ordered Products</Label>
                                      </Col>

                                      <Col lg={12}>
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          data={
                                            selectedOrder &&
                                            selectedOrder.product_details
                                          }
                                          columns={columns}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                        <hr />
                                      </Col>
                                    </div>
                                  </Col>

                                
                                  {selectedOrder &&
                                  selectedOrder.delivery_details &&
                                  selectedOrder.delivery_details.length > 0 ? (
                                    <>
                                      <Link
                                        to="#"
                                        onClick={() => {
                                          printDiv("printDispatched");
                                        }}
                                        className="btn btn-sm btn-success mr-2"
                                      >
                                        <i className="fa fa-print"></i> Print
                                      </Link>
                                      <div id="printDispatched">
                                        <Col lg={12} md={12}>
                                          <Label>
                                            <b>
                                              {props.t("Dispatched Products")}{" "}
                                            </b>
                                          </Label>
                                        </Col>
                                        <Col lg={12} className="mb-4">
                                          <BootstrapTable
                                            bootstrap4
                                            keyField="_id"
                                            data={
                                              selectedOrder.delivery_details
                                            }
                                            columns={columns_delivered_products}
                                            noDataIndication="No data to display."
                                            striped
                                            hover
                                            condensed
                                          />
                                          <hr />
                                        </Col>
                                      </div>
                                    </>
                                  ) : null}

                                 

                                  {isDispatchLoading ? (
                                    <Col lg={12} className="text-center py-4">
                                      <Spinner />
                                    </Col>
                                  ) : selectedOrder?.status !=="Closed" && 
                                  selectedOrder?.status !=="Dispatched" && selectedOrder?.status !=="Partially Dispatched" &&
                                  productsForDelivery &&
                                  productsForDelivery.length > 0 ? (
                                    <>
                                      <Col lg={7} md={7}>
                                        <br />
                                        <Label>
                                          <b>
                                            {props.t("Products to Deliver")}
                                          </b>
                                        </Label>
                                      </Col>
                                      <Col xl={5} lg={5} md={5} sm={5}  className="mb-1 mt-4 text-right">
                                               <Label>&nbsp;</Label>
                        <br />
                        <Button
                          type="submit"
                          color="primary"
                          onClick={() => {
                            setEnterQuantityModal(true);
                            if (selectedOrder && selectedOrder.branch_details) {
                              loadMappedItems(selectedOrder.branch_details);
                            }
                          }}
                          className="btn btn-info waves-effect waves-light btn-md"
                        >
                          <i class="mdi mdi-plus-circle"></i> {props.t("Add Product")}
                        </Button>
                                            </Col>
                                      <Col lg={12}>
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          key="name"
                                          data={
                                            productsForDelivery &&
                                            productsForDelivery
                                          }
                                          // cellEdit={cellEditFactory({
                                          //   mode: "click",
                                          //   blurToSave: true,
                                           
                                          // })}
                                          columns={columns_products_to_dispatch}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                      </Col>
                                      <Col lg={12}>
                                      <hr />
                                      <FormGroup className="mb-0 text-center">
                                        <div>
                                          <Button
                                            onClick={handleDispatchOrder}
                                            color="primary"
                                            className="mr-1"
                                            style={{width:"100px"}}
                                            disabled={isDisabled}
                                          >
                                             {isDisabled ? <Spinner size="sm" /> : props.t("Dispatch")} 
                                          </Button>{" "}
                                        </div>
                                      </FormGroup>
                                    </Col>
                                    </>
                                  ) : null}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>
                  <Modal
                    size="md"
                    isOpen={remarksModal}
                    toggle={() => setRemarksModal(!remarksModal)}
                  >
                    <ModalHeader toggle={() => setRemarksModal(!remarksModal)}>
                      Order ID: {selectedOrder && selectedOrder.order_id}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <AvForm
                                  onValidSubmit={(e, v) =>
                                    setConfirmClose(true)
                                  }
                                >
                                  <Row>
                                    <Col lg={12}>
                                      <AvField
                                        name="admin_remarks"
                                        placeholder="Enter remarks"
                                        type="textarea"
                                        onChange={(e) =>
                                          setAdminRemarks(e.target.value)
                                        }
                                        value={adminRemarks}
                                        label="Remarks"
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage:
                                              "Remarks cannot be empty.",
                                          },
                                        }}
                                      />
                                    </Col>

                                    <Col lg={12}>
                                      <hr />
                                      <FormGroup className="mb-0 text-center">
                                        <div>
                                          <Button
                                            type="submit"
                                            color="primary"
                                            className="mr-1"
                                          >
                                            {props.t("Submit")}
                                          </Button>{" "}
                                        </div>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </AvForm>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>

                  {confirmClose && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmClose(false);
                        handleCloseOrder();
                      }}
                      onCancel={() => {
                        setConfirmClose(false);
                      }}
                    >
                      {props.t(
                        "Once you close this order, it cannot be revoked."
                      )}
                    </SweetAlert>
                  )}

                      {/* Confirm Delete Product  */}
                      {confirmRemove && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmRemove(false);
                        handleRemoveProduct();
                      }}
                      onCancel={() => {
                        setConfirmRemove(false);
                        setSelectedProduct()
                      }}
                    >
                      {props.t("Once you delete this product, it cannot be revoked.")}
                    </SweetAlert>
                  )}
                </CardBody>

                      {/* Edit Units Modal  */}
               
                      <UpdateQuantityModal 
                   isOpen={editQuantityModal}
                   toggle={()=>setEditQuantityModal(false)}
                   onSubmit={handleUpdateQuantity}
                   item={selectedProduct}
                  />

 {/* ---Add/Edit Quantity Modal For New product start--- */}
 <Modal
                    size="md"
                    isOpen={enterQuantityModal}
                    toggle={handleCloseModal}
                  >
                    <ModalHeader toggle={handleCloseModal}>
                      Add Product in {selectedOrder && selectedOrder.branch_details?.name}
                    </ModalHeader>
                    <ModalBody>
                      <>
                            <Card>
                            <CardSubtitle className="mb-1">
                      {props.t( "Enter the following details to add product in dispatch list")}
                    </CardSubtitle>
                              <CardBody>
                              <AvForm onValidSubmit={handleAddProductInDispatch}
                                ref={refForForm} >
                   
                    <Row>
                      <Col lg={12} md={12}>
                        <Label>{props.t("Product")}</Label>
                        {isMappedLoading ? (
                          <div className="text-center py-2">
                            <Spinner size="sm" />
                          </div>
                        ) : (
                        <Select
                          ref={selectRef}
                          // value={sele}
                          onChange={setSelectedProduct}
                          options={allMappedProducts?.filter(
                            (prod) =>
                              !productsForDelivery?.some(
                                (deliveryProd) => deliveryProd.product_id === prod.product_id
                              )
                          )}
                          classNamePrefix="select2-selection"
                          required
                        />
                        )}
                      </Col>
                      {selectedProduct && (
            <>
              <Col lg={12} md={12} >
                <br />
                <p><Label>Central Kitchen Avl.</Label> -&nbsp;
                {formatUnitsForReport(selectedProduct.available,selectedProduct?.unit_levels)}
                 <hr style={{marginBottom:"5px",marginTop:"-5px"}} />
                <Label>{selectedOrder.branch_details?.name} Avl. -&nbsp; </Label> 
                {formatUnitsForReport(selectedProduct.branch_available,selectedProduct?.unit_levels)}
                  </p>
              </Col>
              <Col lg={12} md={12}>
                              <Label>
                                {props.t("Quantity")} in {`${selectedProduct.unit_for_max_order}`}
                              </Label>

                              <AvField
                                name="arrangement_quantity"
                                placeholder={props.t("Enter Quantity")}
                                type="number"
                                min="0"
                                step="1"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Quantity cannot be empty.",
                                  },
                                  pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: props.t(
                                      "Only numbers are allowed."
                                    ),
                                  },
                                  // max: {
                                  //   value:selectedProduct && selectedProduct.max_order_limit,
                                  //   errorMessage: selectedProduct &&
                                  //     props.t("Cannot enter more than ") +
                                  //     selectedProduct.max_order_limit +" " +selectedProduct.unit_for_max_order +".",
                                  // },
                                  min: {
                                    value:1,
                                    errorMessage: props.t("Minimum 1 is required"),
                                  },
                                }}
                              />
                            </Col>
            </>
          )}
          
          <Col lg={12}>
                                      <hr />
                                      <FormGroup className="mb-0 text-center">
                                        <div>
                                          <Button
                                            color="primary"
                                            className="mr-1"
                                            style={{width:"80px"}}
                                            disabled={isAdding}
                                          >
                                             {isAdding ? <Spinner size="sm" /> : props.t("Add")} 
                                          </Button>
                                        </div>
                                      </FormGroup>
                                    </Col>
                
                  
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                              </CardBody>
                            </Card>
                      </>
                    </ModalBody>
                  </Modal>
                    {/* ---Add/Edit Quantity Modal For New product end--- */}

                  <Modal
                    size="md"
                    isOpen={rejectModal}
                    toggle={() => setRejectModal(!rejectModal)}
                  >
                    <ModalHeader toggle={() => setRejectModal(!rejectModal)}>
                      {props.t("Reject Product Order")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  setConfirmReject(true);
                                }}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="admin_remarks"
                                      onChange={(e) => {
                                        setRejectRemarks(e.target.value);
                                      }}
                                      label={props.t("Remarks")}
                                      placeholder={props.t("Enter Remarks")}
                                      type="textarea"
                                      errorMessage="Remarks cannot be empty."
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Submit")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

{confirmApprove && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmApprove(false);
                        handleApproveOrder();
                      }}
                      onCancel={() => {
                        setConfirmApprove(false);
                      }}
                    >
                      {props.t(
                        "Once you accept this order, it cannot be revoked."
                      )}
                    </SweetAlert>
                  )}

{confirmReject && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmReject(false);
                        handleRejectOrder();
                      }}
                      onCancel={() => {
                        setConfirmReject(false);
                      }}
                    >
                      {props.t(
                        "Once you reject this order, it cannot be revoked."
                      )}
                    </SweetAlert>
                  )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(FinishedProductUrgentOrders))
);
